export default {"src":"/_next/static/media/min-pin.5e4de6e1.svg","height":34,"width":24,"blurWidth":0,"blurHeight":0};